// extracted by mini-css-extract-plugin
export var wrapper = "video-playlist-module--wrapper--2bUDs";
export var video = "video-playlist-module--video--3zsUS";
export var picker = "video-playlist-module--picker--1PaJ5";
export var pickerItem = "video-playlist-module--picker-item--2bTSM";
export var thumbnail = "video-playlist-module--thumbnail--2ob_m";
export var info = "video-playlist-module--info--1wKxD";
export var active = "video-playlist-module--active--2HYap";